import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import clsx from "clsx";

import Launch from "@material-ui/icons/Launch";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import {
  setSelectedRaceId,
  setSelectedFacilityId
} from "store/actions/conditionBookPage";
import { setBackArrowVisibility } from "store/actions/sidebar";
import routes from "common/routes";
import useStyles from "./styles";

interface IProps {
  races: racehorse360.IRaceCondition[];
  smallWidthIconColumn?: boolean;
}

const MatchedRacesList = React.memo((props: IProps) => {
  const { races, smallWidthIconColumn = false } = props;
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleLinkClick = (raceId: string, facilityId?: string) => () => {
    dispatch(setBackArrowVisibility(true));
    dispatch(setSelectedRaceId(raceId));
    dispatch(setSelectedFacilityId(facilityId));
  };

  const renderRaces = () => {
    return races.map((race: racehorse360.IRaceCondition) => {
      return (
        <Link
          key={race.id}
          to={routes.conditionBook.path}
          className={clsx(classes.raceItem, {
            ["withSmallWidthIcon"]: smallWidthIconColumn
          })}
          onClick={handleLinkClick(race.id, race.facility?.id)}
        >
          <span className={clsx(classes.textCell, classes.boldText)}>
            {race.facility?.code}
          </span>
          <span className={clsx(classes.textCell, classes.codeCell)}>
            {race.code}
          </span>

          <span className={clsx(classes.textCell)}>
            {format(parseISO(race.raceDate), "MMM d")}
            {(race.surface === racehorse360.CourseSurface.COURSE_SURFACE_TURF ||
              race.surface ===
                racehorse360.CourseSurface.COURSE_SURFACE_DOWNHILL_TURF) &&
              " (T)"}
          </span>
          <Launch className={classes.linkIcon} />
        </Link>
      );
    });
  };

  return <>{renderRaces()}</>;
});

export default MatchedRacesList;
